import { TableGridBaseColDef } from '@components/table/types/TableColumnDef.type';
import { Box } from '@mui/material';
import { iconsByCardType } from '@pages/QuoteDetails/sidebarItems/SidebarCard';
import { Typography } from '@mui/material';
import { OverflowTooltip } from '@components/tooltip/OverflowTooltip';
import { IssueType } from '@pages/QuoteDetails/sidebarItems/underwriting/Underwriting.constants';
import { format } from 'date-fns';
import { getDateFormatter } from '@utils/date';
import { ClockFormat } from '@lio/rule-engine';
import { LongDateFormatWithoutSeconds } from '@utils/date';

export const getUWIssuesColumns = (
  handleEditClick: (row: IssueType) => void,
  clockFormat: ClockFormat,
): TableGridBaseColDef<IssueType>[] => {
  const iconStyle = { height: '20px', width: '20px', alignSelf: 'center' };

  return [
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      sortable: false,
      renderCell: ({ row }: { row: IssueType }) => {
        return (
          <Box
            sx={{
              display: 'flex',
              alignContent: 'center',
              height: '100%',
              gap: 1,
              svg: {
                fill: (theme) => {
                  if (row.status === 'Accepted') {
                    return theme.palette.success.dark;
                  } else if (row.status === 'Rejected') {
                    return theme.palette.error.main;
                  } else {
                    return theme.palette.warning.main;
                  }
                },
                path: {
                  fill: (theme) => {
                    if (row.status === 'Accepted') {
                      return theme.palette.success.dark;
                    } else if (row.status === 'Rejected') {
                      return theme.palette.error.main;
                    } else {
                      return theme.palette.warning.main;
                    }
                  },
                },
              },
            }}
          >
            <Box sx={{ width: '20px', display: 'flex', alignContent: 'center' }}>
              {row.status === 'Accepted'
                ? iconsByCardType(iconStyle).UnderwritingIssue.accepted
                : row.status === 'Rejected'
                  ? iconsByCardType(iconStyle).UnderwritingIssue.rejected
                  : iconsByCardType(iconStyle).UnderwritingIssue.open}
            </Box>
            <Typography
              variant='bodySmall'
              sx={{
                alignSelf: 'center',
              }}
            >
              {row.status === 'Accepted' ? 'Accepted' : row.status === 'Rejected' ? 'Rejected' : 'Open'}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'title',
      headerName: 'Issue',
      minWidth: 200,
      sortable: false,
      renderCell: ({ row }: { row: IssueType }) => (
        <OverflowTooltip tooltipText={row.title || row.description || ''}>
          <Typography variant='bodySmall'>{row.title || row.description || ''}</Typography>
        </OverflowTooltip>
      ),
    },

    {
      field: 'reasoning',
      headerName: 'Reason',
      minWidth: 300,
      sortable: false,
      renderCell: ({ row }: { row: IssueType }) => (
        <OverflowTooltip tooltipText={row.reasoning}>
          <Typography variant='bodySmall'>{row.reasoning}</Typography>
        </OverflowTooltip>
      ),
    },
    {
      sortable: false,
      field: 'author',
      headerName: 'Created By',
      valueGetter: (col, row) => `${row.author?.firstName || ''} ${row.author?.lastName || ''}`.trim(),
    },
    {
      field: 'createdAt',
      headerName: 'Date',
      sortable: false,
      valueGetter: (col, row) =>
        row.createdAt
          ? format(new Date(row.createdAt), getDateFormatter(clockFormat, LongDateFormatWithoutSeconds))
          : '',
    },
  ];
};
